module.exports = __webpack_public_path__ + "img/550b2c8f12bf37d04ce1a87e586a998d.svg";